import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

interface NavigationMenuProps {
  currentPage: 'main' | 'past-topics' | 'my-topic-stats' | 'deleted-topics' | 'about';
  currentTeamId?: string | null;
  onNavigate: (page: 'main' | 'past-topics' | 'my-topic-stats' | 'deleted-topics' | 'submit-topic' | 'about') => void;
}

const NavigationMenu: React.FC<NavigationMenuProps> = ({ currentPage, currentTeamId, onNavigate }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavClick = (page: 'main' | 'past-topics' | 'my-topic-stats' | 'deleted-topics' | 'submit-topic' | 'about') => {
    // Handle submit-topic through callback (modal)
    if (page === 'submit-topic') {
      onNavigate(page);
      return;
    }

    // Handle my-topic-stats (series-agnostic)
    if (page === 'my-topic-stats') {
      navigate('/my-stats');
      return;
    }

    // Handle about (series-agnostic - always /about)
    if (page === 'about') {
      navigate('/about');
      return;
    }

    // For other pages, use URL navigation if we have a teamId
    if (currentTeamId) {
      const pageMap = {
        'main': 'scheduled-topics',
        'past-topics': 'past-topics',
        'deleted-topics': 'deleted-topics'
      };
      navigate(`/series/${currentTeamId}/${pageMap[page]}`);
    } else {
      // No team selected - use callback for state-based navigation
      onNavigate(page);
    }
  };

  return (
    <nav className="navigation-menu">
      <span 
        className="nav-item nav-submit-topic"
        onClick={() => handleNavClick('submit-topic')}
      >
        + Submit New Topic
      </span>
      <span className="nav-separator">|</span>
      <span 
        className={`nav-item ${currentPage === 'main' ? 'active' : ''}`}
        onClick={() => handleNavClick('main')}
      >
        Scheduled Topics
      </span>
      <span className="nav-separator">|</span>
      <span 
        className={`nav-item ${currentPage === 'past-topics' ? 'active' : ''}`}
        onClick={() => handleNavClick('past-topics')}
      >
        Past Topics
      </span>
      <span className="nav-separator">|</span>
      <span 
        className={`nav-item ${currentPage === 'my-topic-stats' ? 'active' : ''}`}
        onClick={() => handleNavClick('my-topic-stats')}
      >
        My Topic Stats
      </span>
      <span className="nav-separator">|</span>
      <span 
        className={`nav-item ${currentPage === 'deleted-topics' ? 'active' : ''}`}
        onClick={() => handleNavClick('deleted-topics')}
      >
        Deleted Topics
      </span>
      <span className="nav-separator">|</span>
      <span 
        className={`nav-item ${currentPage === 'about' ? 'active' : ''}`}
        onClick={() => handleNavClick('about')}
      >
        About
      </span>
    </nav>
  );
};

export default NavigationMenu;
